<template>
  <div class="Trafficlight" :class="className">
    <div class="light-box" :class="main ? 'main' : ''">
      <div class="light-item" :class="className === 'red' ? 'red' : ''"></div>
      <div
        class="light-item"
        :class="className === 'yellow' ? 'yellow' : ''"
      ></div>
      <div
        class="light-item"
        :class="className === 'green' ? 'green' : ''"
      ></div>
    </div>
    <div class="desc-group" :class="main ? 'main' : ''">
      <div class="desc">{{ className === 'unknown' ? 'unknown' : '' }}</div>
      <div class="desc">{{ !!main ? main : '' }}</div>
      <div class="desc">{{ !!title ? title : '' }}</div>
      <div class="desc">id：{{ remainingTimes || '--' }}</div>
      <div class="desc">duration：{{ totalTimes || '--' }}秒</div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  remainingTimes: String,
  totalTimes: String,
  className: String,
  title: String,
  main: String,
});
</script>

<style lang="less" scoped>
.Trafficlight {
  position: relative;
  color: #fff;
  align-items: center;
  text-align: left;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  width: 240px;
  height: 120px;

  .desc {
    width: 180px;
    font-size: 12px;
    background-size: 100% 100%;
    padding-left: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 7px;
  }

  .light-box {
    border-radius: 23px;
    width: 46px;
    height: 98px;
    background: #3a2b2b;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0;
    box-sizing: border-box;
    align-items: center;

    .light-item {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #575757;
      box-shadow: 0 4px 8px 0 #0000003d;

      &.red {
        background: #ff3134;
      }

      &.yellow {
        background: #ffb637;
      }

      &.green {
        background: #37ffb9;
      }
    }

    &.main {
      background: #003d3b;
    }
  }
}

.main {
  color: aqua;
}
</style>
